<template>
  <section>
    <div class='banner'>
      <img src="../assets/images/banner.png" alt="">
      <div class="content">
        <p class='bannerIntro' v-html="text1"></p>

          <!--<p class='enIntro'>1、SEM竞价推广预算<br/> </p>-->
          <!--<P class='enIntro'>2、推广平台及预算的分配</P>-->
          <!--<P class='enIntro'>3、关键词如何选择-->
              <!--不同的关键词在不同的时间段排名、都是会发生变化的，每个行业都是有一些精准的关键词，精准的关键词带来的转化率也是不一样的。在通过核心精准关键词，拓展相关的长尾词进行筛选，按关键词属性分组，设置合理的排名及价格。-->
          <!--</P>-->
          <!--<P class='enIntro'>4、匹配关键词-->
              <!--每个行业搜索客户搜索的习惯都是不一样的，这个时候要通过客户的想法来匹配关键词，只有匹配精准的关键词，这样转化率才会高。（关键词匹配有四种模式：短语匹配-精准匹配-广泛匹配-否定匹配）-->
          <!--</P>-->
          <!--<P class='enIntro'>5、吸睛描述-->
              <!--描述在排名中最大的价值就是吸引用户去点击，因此我们在写网站描述的时候，要把网站的特色特点写出来，首先要抓住这几点：吸引力-卖点-飘红-相关-通顺-->
          <!--</P>-->
          <!--<P class='enIntro'>6、关键词排名位置分布建议 公司品牌关键词在1-2位，行业关键词3-5位，竞争比较热的关键词放在后面，精准关键词放在前面。</P>-->
          <!--<P class='enIntro'>8、SEM推广时间段分配 根据经验，一天当中有三个高峰期，上午11点、下午3点及晚上九点，在这几个时间段可加大投放，获取更多目标客户。</P>-->
        <!--<p class='enIntro'>Ecological chain soltion SEM</p>-->
        <a href="#detail" style="color: #fff;"> <P class='btn'>了解详情 →</P></a>
        <!--<p class="list">-->
          <!--<span></span>-->
          <!--<span></span>-->
          <!--<span></span>-->
        <!--</p>-->
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    name: 'BannerBg',
    data() {
      return {
      
      }
    },
    props:['text1']
  }
</script>
<style scoped lang='scss'>
  section{
    .banner{
      position: relative;
      left: 0;
      top: 0;
      z-index: 10;
      img{
        width: 100%;
        display: block;
      }
      .content{
        position: absolute;
        left: 0;
        top: 0;
        padding-left: 2.5rem;
        color: #fff;
        text-align: left;
        .bannerIntro{
          font-size: 0.5rem;
          padding-top: 0.26rem;
        }
        .enIntro{
          color: #A7ADCC;
          margin-top: 0.15rem;
        }
        .btn{
          width: 130px;
          height: 38px;
          line-height: 38px;
          font-size: 14px;
          background: #FC5F35;
          margin-top: 0.25rem;
          color: #fff;
          text-align: center;
          border-radius: 4px;
          cursor: pointer;
        }
        .list{
          margin-top: 0.15rem;
          span{
            display: inline-block;
            width: 18px;
            height: 4px;
            background: #FC5F35;
            &:nth-of-type(1), &:nth-of-type(2){
              background: #777;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BannerBg.vue